import { Navigate, NavLink, Outlet } from "react-router-dom";

import { useAppStore } from "@/store/auth";

const TABS = [
  { to: "/admin/users", label: "用户" },
  { to: "/admin/audit", label: "审计" },
  { to: "/admin/health", label: "系统状态" },
  { to: "/admin/stats", label: "统计" },
];

export default function AdminLayout() {
  const me = useAppStore((s) => s.me);

  // 未加载完成时不渲染（getMe 还在飞）：避免 Navigate 提前跳走
  if (me === null) {
    return (
      <div className="mx-auto max-w-5xl px-4 py-12 text-center text-sm text-slate-500">
        加载中…
      </div>
    );
  }

  if (!me.is_admin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="mx-auto max-w-5xl p-4">
      <div className="mb-4 flex flex-wrap items-center gap-1 border-b border-slate-200 pb-2 text-sm">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `rounded-full px-3 py-1 transition ${
                isActive
                  ? "bg-slate-900 text-white"
                  : "text-slate-600 hover:bg-slate-100"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
